export default "__VITE_ASSET__Ba4sthvK__"